import * as Sentry from '@sentry/browser';
import {
  CertificationRecordsQueryQuery,
  CertificationRecordsQueryQueryVariables,
  type CertificationRecord,
} from '__generated__/graphql';
import { useToastOpen } from 'contexts/ToastContext';
import gql from 'graphql-tag';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { t } from 'utils/localize';

export const certificationRecordsQuery = gql`
  query CertificationRecordsQuery(
    $filter: CertificationRecordFilter
    $sort: [CertificationRecordSort!]
    $after: String
    $first: Int
  ) {
    certificationRecords(filter: $filter, sort: $sort, first: $first, after: $after) {
      id
      memberId
      certificationId
    }
  }
`;

export type IUseCertificationRecordsRequestResult = Pick<CertificationRecord, 'id' | 'memberId' | 'certificationId'>;

export function useCertificationRecordsRequest() {
  const graphqlClient = useGraphQLClient();
  const toastOpen = useToastOpen();

  return (variables: CertificationRecordsQueryQueryVariables): Promise<IUseCertificationRecordsRequestResult[]> => {
    const requestConfig = { document: certificationRecordsQuery, variables };

    return graphqlClient
      .request<CertificationRecordsQueryQuery, CertificationRecordsQueryQueryVariables>(requestConfig)
      .then((result) => result.certificationRecords ?? [])
      .catch((error: unknown) => {
        toastOpen({ label: t('Failed to load Certification Records.') });
        Sentry.captureException(error, { extra: { requestConfig, variables } });
        // eslint-disable-next-line no-console
        console.error('Error fetching Certification Records:', { error, requestConfig });

        return [];
      });
  };
}
